import TechnicalOverlayDepartment from './TechnicalOverlayDepartment';

export default TechnicalOverlayDepartment;
